import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top on every route change.
 * When a hash is present, scrolls to that element instead.
 */
export function ScrollToTop() {
  const { pathname, hash, state } = useLocation();
  const scrollTo = (state as { scrollTo?: string } | null)?.scrollTo;

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      const run = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      requestAnimationFrame(() => {
        run();
        window.setTimeout(run, 80);
      });
      return;
    }
    if (scrollTo) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, scrollTo]);

  return null;
}
